import type { Federation } from '@proref/types';
import type { CreateFederationInput, UpdateFederationInput } from '@proref/schemas';
import { api, unwrap, type Envelope } from '../lib/api';

export async function listFederations(): Promise<Federation[]> {
  const res = await api.get<Envelope<Federation[]>>('/federations');
  return unwrap(res.data);
}

export async function createFederation(input: CreateFederationInput): Promise<Federation> {
  const res = await api.post<Envelope<Federation>>('/federations', input);
  return unwrap(res.data);
}

// Edit a tenant (super_admin only).
export async function updateFederation(
  id: string,
  input: UpdateFederationInput,
): Promise<Federation> {
  const res = await api.patch<Envelope<Federation>>(`/federations/${id}`, input);
  return unwrap(res.data);
}

// Delete a tenant (super_admin only). The API refuses (409) if it still has members/clips/exams.
export async function deleteFederation(id: string): Promise<void> {
  await api.delete<Envelope<null>>(`/federations/${id}`);
}
